var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "scene" }, [
    _c("img", {
      attrs: {
        src: _vm.loading,
        oncontextmenu: "return false;",
        ondragstart: "return false;",
        alt: "",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/live-loading.vue?vue&type=template&id=10c7f3eb&scoped=true&
// module id = null
// module chunks = 